import * as angular from 'angular';
import { NetworkPointResource } from 'app/_resources/network-point.resource';

(function () {
    'use strict';

    angular.module('app').directive('manageQuickFilter', manageQuickFilter);

    /**
     * A directive for editing and adding new quick filters.
     *
     * @author flzemke.btc
     * @ngInject
     */
    function manageQuickFilter() {
        return {
            restrict: 'E',
            scope: {
                quickFilterName: '=',
                selectedNetworkPoints: '='
            },
            template: require('app/_directives/manage-quick-filter.directive.html'),
            compile: compileFn,
            controller: controllerFn,
            controllerAs: 'manageQuickFilterCtrl'
        };

        function compileFn() {}

        function controllerFn(
            $scope,
            $rootScope,
            platformSettingsService,
            NetworkPoint: NetworkPointResource,
            NETWORK_POINT_SEARCH_MODE
        ) {
            var vm = this;

            vm.NETWORK_POINT_SEARCH_MODE = NETWORK_POINT_SEARCH_MODE;
            vm.newQuickFilterForm = {};
            vm.newQuickFilter = {};
            vm.newQuickFilter.name = angular.copy($scope.quickFilterName);
            vm.submitNewQuickFilter = submitNewQuickFilter;
            vm.cancel = cancel;

            function submitNewQuickFilter(selectedNetworkPoints) {
                vm.newQuickFilterForm.$setSubmitted(true);
                if (!vm.newQuickFilterForm.$valid) {
                    return false;
                }

                NetworkPoint.deleteQuickFilter(
                    { name: $scope.quickFilterName },
                    function () {
                        NetworkPoint.addQuickFilter(
                            {
                                name: vm.newQuickFilter.name,
                                networkPointList: selectedNetworkPoints
                            },
                            function () {
                                $rootScope.$broadcast(
                                    platformSettingsService.BROADCAST
                                        .EDIT_QUICK_FILTER,
                                    {
                                        name: vm.newQuickFilter.name,
                                        selectedNetworkPoints:
                                            selectedNetworkPoints,
                                        oldName: $scope.quickFilterName
                                    }
                                );
                            },
                            function () {
                                $rootScope.$broadcast(
                                    platformSettingsService.BROADCAST
                                        .EDIT_QUICK_FILTER,
                                    {
                                        error: true
                                    }
                                );
                            }
                        );
                    },
                    function () {
                        $rootScope.$broadcast(
                            platformSettingsService.BROADCAST.EDIT_QUICK_FILTER,
                            {
                                error: true
                            }
                        );
                    }
                );

                return true;
            }

            function cancel() {
                $rootScope.$broadcast(
                    platformSettingsService.BROADCAST.CANCEL_EDIT_QUICK_FILTER
                );
            }
        }
    }
})();
